export default {"src":"/_next/static/media/logo_web_GNB_black.841b41b8.svg","height":32,"width":85,"blurWidth":0,"blurHeight":0};